
import { Fab, IconButton, FabProps, Theme } from '@mui/material';
import React from 'react';
import { keyframes } from '@mui/system';

const wobble = keyframes`
	0% { transform: scale(0.6); }
	40% { transform: scale(1.15); }
	60% { transform: scale(0.92); }
	80% { transform: scale(1.04); }
	100% { transform: scale(1); }
`;

/** Plays once whenever a button mounts, drawing attention to a changed set of actions. */
const wobbleOnMount = `${wobble} 500ms ease-in-out`;

type ActionAreaFabProps<C extends React.ElementType = 'button'> = FabProps<C, { component?: C }>;

export function ActionAreaFab<C extends React.ElementType = 'button'>({ sx, color, ...fabProps }: ActionAreaFabProps<C>) {
	return <Fab {...fabProps} color={color ?? 'primary'} sx={{
		animation: wobbleOnMount,
		color: (theme) => (theme as Theme).palette.primary.contrastText,
		'&:visited': { color: (theme) => (theme as Theme).palette.primary.contrastText},
		...sx,
	}} />;
}

export function ActionAreaBtn<C extends React.ElementType = 'button'>({ sx, ...fabProps }: ActionAreaFabProps<C>) {
	return <IconButton size='large' {...fabProps} sx={{
		animation: wobbleOnMount,
		color: (theme) => (theme as Theme).palette.primary.main,
		backgroundColor:'divider',
		'&:hover': { backgroundColor: (theme) => (theme as Theme).palette.action.hover },
		backdropFilter: 'blur(8px)',
		...sx,
	}} />;
}
